import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import icoGoBack from '../../../assets/images/ico_goback.png';
import TabsMenu from '../../../components/button/tab-menu';
import CenterTabs from '../atoms/center_tabs';

const CenterDetail = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: centerId } = useParams();

  const accountId = '';
  // const { setGModal, loading, setLoading } = props;
  const [centerName, setCenterName] = useState(null);
  const [component, setComponent] = useState(
    CenterTabs({
      ...props,
      setCenterName: setCenterName,
      centerId: centerId,
      // accountId: accountId,
    })[0].component
  );
  // 초기화

  //----------------------------------------------------------------------------------------------------

  return (
    <div style={{ ...styles.constainer }}>
      <div style={{ ...styles.header }}>
        <Button
          style={{
            display: 'flex',
            width: '2.4rem',
            height: '2.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          icon={<img width={24} height={24} src={icoGoBack} />}
          onClick={(e) => {
            // goback
            // navigate(-1);
            navigate('/centers', {
              replace: false,
              state: {
                ...location.state,
                isBack: true,
              },
            });
          }}
        />
        <div style={{ marginLeft: '2rem' }}>{`${
          centerName || '-'
        } 상세보기`}</div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.tabs }}>
        <TabsMenu
          {...props}
          items={CenterTabs({
            ...props,
            setCenterName: setCenterName,
            centerId: centerId,
            accountId: accountId,
          })}
          checkedIdx={1}
          setComponent={setComponent}
        />
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      {component}
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  constainer: {
    display: 'flex',
    width: '100%',
    // flex: 1,
    // height: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  header: {
    display: 'flex',
    width: '100%',
    height: '4.6rem',
    alignItems: 'center',
    padding: '0rem 1rem 0rem 1rem',
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    borderRadius: '0.6rem',

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    color: '#4B465C',
  },
  tabs: {
    display: 'flex',
    width: '100%',
    height: '9rem',
    alignItems: 'center',
  },
};
export default CenterDetail;
